module.exports = __webpack_public_path__ + "img/157.c3bea8a0.png";